import axios from 'axios';

export async function downloadFile({
  url,
  params = {},
  token,
  fileType, // 'excel' | 'pdf'
  fileName = 'download',
}) {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await axios.get(`${url}?${query}`, {
      responseType: 'blob',
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });

    // Set MIME type & extension
    let mimeType = '';
    let ext = '';
    if (fileType === 'pdf') {
      mimeType = 'application/pdf';
      ext = '.pdf';
    } else if (fileType === 'excel') {
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      ext = '.xlsx';
    } else {
      throw new Error('Unsupported fileType');
    }

    const blob = new Blob([response.data], { type: mimeType });
    const urlBlob = window.URL.createObjectURL(blob);

    // Get filename from server, else fallback
    const contentDisposition = response.headers['content-disposition'];
    let filename = contentDisposition
      ? contentDisposition.split('filename=')[1]?.replace(/"/g, '')
      : `${fileName}_${Date.now()}${ext}`;

    // Ensure correct extension
    if (!filename.endsWith(ext)) {
      filename += ext;
    }

    // Create invisible link
    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(urlBlob);
    return { success: true };
  } catch (error) {
    console.error('Download error:', error);
    return { success: false, error };
  }
}
